<template>
  <div
    :class="`formulate-input-element formulate-input-element--${context.type} input-${size}`"
    :data-type="context.type"
  >
    <date-picker
      v-bind="context.attributes"
      v-model="context.model"
      :value-type="context.attributes?.valueType || context.attributes?.['value-type'] || 'format'"
      :placeholder="$t(context.attributes?.placeholder) || $t('global.action.selectDate')"
      :type="datepickerType"
      ref="periodePicker"
      @blur="context.blurHandler()"
      @pick="pick"
      @close="close"
      :lang="datePickerLang"
      :clearable="clearable"
    >
      <template #footer v-if="context.attributes.cancel">
        <b-button class="mx-2" variant="outline-primary" @click="closeCalendar()">{{
          $t('global.action.cancel')
        }}</b-button>
      </template>
      <template #icon-calendar>
        <i :class="icon"></i>
      </template>
    </date-picker>
  </div>
</template>

<script>
import datePickerLang from '@/helpers/date-picker-lang'
export default {
  props: {
    context: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
    datepickerType: {
      type: String,
      default: 'date',
    },
    clearable: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'icon-outline_calendar'
    },
  },

  computed: {
    datePickerLang() {
      return datePickerLang()
    },
  },

  methods: {
    closeCalendar() {
      this.$refs.periodePicker.defaultOpen = false
    },
    pick(date) {
      (this.$listeners && this.$listeners.pick) && this.$emit('pick', date)
    },
    close(date) {
      (this.$listeners && this.$listeners.close) && this.$emit('close', date)
    }
  },
}
</script>
